export const pricingPlans = [
 {
id: 'basic',
tag: 'Budget Friendly',
price: '$10',
frequency: '/month',
title: 'Basic',
subtitle: 'For Individuals & Small Teams',
isContact: false,
buttonText: 'Choose plan',
features: [
 { text: 'Essential features', included: true },
 { text: 'Limited projects/tasks', included: true },
 { text: 'Basic analytics & reporting', included: true },
 { text: 'Email support', included: true },
 { text: 'Community access', included: true },
],
 },
 {
id: 'pro',
tag: 'Most Popular',
price: '$20',
frequency: '/month',
title: 'Pro',
subtitle: 'For Growing Businesses',
isContact: false,
buttonText: 'Choose plan',
features: [
 { text: 'Unlimited projects & tasks', included: true },
 { text: 'Advanced analytics', included: true },
 { text: 'Custom branding options', included: true },
 { text: 'Integrations with all apps', included: true },
 { text: 'Priority support', included: true },
],
 },
 {
id: 'enterprise',
tag: 'Tension Free', 
price: '$50',
frequency: '/month',
title: 'Enterprise',
subtitle: 'For Individuals & Small Teams',
isContact: false,
buttonText: 'Choose plan',
features: [
 { text: 'Everything in Pro', included: true },
 { text: 'Dedicated account manager', included: true },
 { text: 'Advanced security & features', included: true },
 { text: 'API access & Integrations', included: true },
 { text: '24/7 Premium Support', included: true },
],
 },
 {
id: 'organization',
tag: 'Exclusive',
price: '$$$$', 
frequency: '/month',
title: 'Organization',
subtitle: 'Need a separate solution? no problem - get in touch today',
isContact: true,
buttonText: 'Choose plan',
features: [], 
 },
];